/**
 * 페이지 연타처럼 같은 조회를 연달아 쏠 때, 늦게 도착한 이전 응답이 최신 상태를
 * 덮지 않도록 막는 시퀀스 가드. 요청 직전에 `begin()`으로 판정 함수를 받아,
 * 콜백(next/error)마다 `isLatest()`가 false면 상태를 건드리지 말고 반환한다.
 */
export class LatestRequestGuard {
  private seq = 0;

  begin(): () => boolean {
    const current = ++this.seq;
    return () => current === this.seq;
  }
}
